import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';
import * as yup from 'yup';

export async function deleteSelectedAdditionalsGroupsByGroup(id) {
  try {
    const idValidation = yup.string().required().nonNullable();

    await idValidation.validate(id);

    await api.delete(`/grupo-adicionais/${id}`);

    return new Success();
  } catch (error) {
    console.log(error);

    return new Failure();
  }
}
